import aiHeader from "../../../assets/ai-modal-step-1.svg";
import step2Img from "../../../assets/ai-modal-step-2.webp";
import step3Img from "../../../assets/ai-modal-step-3.webp";
import step4Img from "../../../assets/ai-modal-step-4.webp";
import finalStepImg from "../../../assets/ai-modal-step-5.svg";

export const STEP_HEADER_CONFIG = {
  intro: { bgImage: aiHeader, headerHeight: "13.75rem" },
  "session-notes": {
    bgImage: step2Img,
    headerHeight: "332px",
    bgSize: "auto 300px",
  },
  "intake-reports": {
    bgImage: step3Img,
    headerHeight: "332px",
    bgSize: "auto 300px",
  },
  "ai-chat": { bgImage: step4Img, headerHeight: "332px", bgSize: "auto 300px" },
  "final-consent": {
    bgImage: finalStepImg,
    headerHeight: "120px",
    bgSize: "auto 48px",
  },
};
